import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class NoticeService {
  private $api: string = '';
  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 모든 공지사항 목록 획득
   */
  notice(centerNum: string|number): Promise<{
    crm_num: number,
    emp_num: number,
    crm_content: string,
    crm_subject: string,
    crm_date: string,
    crm_count: number,
    cce_num: number,
    company_num: number,
  }[]> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `notices/${centerNum}`,
    ).toPromise();
  }

  /**
   * 범위가 있는 공지사항 목록 획득
   */
  limitNotice(centerNum: string|number, sIndex: number, cnt:number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `notices/${centerNum}/${sIndex}/${cnt}`,
    );
  }

  /**
   * 사용자가 읽은 공지사항 목록 획득
   */
  readNotice(): Promise<{
    cnr_num: number,
    crm_num: number,
    bm_num: number,
  }[]> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + 'user/notices',
    ).toPromise();
  }

  /**
   * 공지사항 읽은 목록 추가
   */
  addNotice(noticeNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'POST',
      this.$api + `user/notices`,
      { noticeNum },
    );
  }
}
